import { createReducer, on } from '@ngrx/store';
import { CartonContents, Product, SuggestedCartonDto } from '../models';
import { sortingActions } from '../actions/sorting.actions';

export interface SortingState {
    // The last scanned product; non-null means the next scan is the target carton code.
    product: Product | null;
    // Server-suggested target cartons for the last scanned product.
    suggestions: SuggestedCartonDto[];
    // Contents of the carton the last item landed in — the running total feedback.
    contents: CartonContents | null;
    scanning: boolean;
    saving: boolean;
}

export const initialState: SortingState = {
    product: null,
    suggestions: [],
    contents: null,
    scanning: false,
    saving: false,
};

export const sortingReducer = createReducer(
    initialState,
    // Scan product
    on(sortingActions.scanProduct, (state): SortingState => ({
        ...state,
        scanning: true,
    })),
    on(sortingActions.scanProductSuccess, (state, { payload }): SortingState => ({
        ...state,
        scanning: false,
        product: payload.product,
        suggestions: payload.suggestions,
        contents: null,
    })),
    on(sortingActions.scanProductError, (state): SortingState => ({
        ...state,
        scanning: false,
    })),
    // Add item
    on(sortingActions.addItem, (state): SortingState => ({
        ...state,
        saving: true,
    })),
    on(sortingActions.addItemSuccess, (state, { payload }): SortingState => ({
        ...state,
        saving: false,
        product: null,
        suggestions: [],
        contents: payload,
    })),
    on(sortingActions.addItemError, (state): SortingState => ({
        ...state,
        saving: false,
    })),
    // Clear
    on(sortingActions.clear, (): SortingState => ({ ...initialState })),
);
